import Loader from "./Loader";
import Footer from "./Footer";
import Topbar from "./Topbar";
import RightSidebar from "./RightSidebar";
import StudentRightSidebar from "./StudentRightSidebar";
import AuthLayout from "./AuthLayout";
import StudentLayout from "./StudentLayout";
import Table from "./Table";
import PrivateRoute from "./PrivateRoute";
import Wrapper from "./Wrapper";
import Pagination from "./Pagination";
import FormElements from "./FormElements";
import Category from "./Category";
import SubCategory from "./SubCategory";
import Video from "./Video";
import Subscription from "./Subscription";
import Course from "./Course";
import Session from "./Session";
import ModalManager from "./ModalManager";
import Comment from "./Comment";
import PerfectScrollbar from "./PerfectScrollbar";
import Toggle from "./Toggle";
import Rating from "./Rating";
import Preloader from "./Preloader";
import Select from "./Select";
import Popover from "./Popover";
import Player from "./Player";
import Orders from "./Orders";
import TeacherLayout from "./TeacherLayout";
export {
  Loader,
  Footer,
  Topbar,
  RightSidebar,
  AuthLayout,
  StudentRightSidebar,
  StudentLayout,
  Table,
  PrivateRoute,
  TeacherLayout,
  Wrapper,
  Pagination,
  Orders,
  FormElements,
  Category,
  SubCategory,
  Video,
  Subscription,
  Course,
  Session,
  ModalManager,
  Comment,
  PerfectScrollbar,
  Toggle,
  Rating,
  Preloader,
  Select,
  Popover,
  Player
};
